//@ts-check
import {Modal} from '@/components-v2/organisms'

/**
 * Confirmation modal shown when discarding unsaved Product List edits.
 * @param {{ showModal: boolean; onConfirm: () => void; onCancel: () => void }} props
 */
export const DiscardChangesModal = ({showModal, onConfirm, onCancel}) => (
  <Modal
    showModal={showModal}
    onCloseModal={onCancel}
    hideCloseButton
    type="S"
    title="Discard changes?"
    text="You've made changes to one or more products. These changes haven't been saved and will be lost if you continue."
    showPrimaryButton
    primaryButtonProps={{text: 'Discard changes', onClick: onConfirm}}
    showTertiaryButton
    tertiaryButtonProps={{text: 'Keep Editing', onClick: onCancel}}
  />
)
